import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { renderToStaticMarkup } from 'react-dom/server';
import { getManufacturedProducts, clearManufacturedProducts } from '../production/productionActions';
import { getManufacturingPolicyTypes, getUser } from '../user-management/userActions';
import { getOrder } from '../order/orderActions';
import { useAuth } from "../../../app/modules/auth";
import ProductionsList from '../production/ProductionsList';
import OrderComponentPrint from '../order/orderComponentPrint';
import { enumPolicies } from '../../../_metronic/helpers/enumPolicies';
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker';

const DashboardProductions = (props) => {
    const intl = useIntl();
    const { currentUser } = useAuth();
    const [userManufacturingProductGroups, setUserManufacturingProductGroups] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [expandedOrder, setExpandedOrder] = useState(null);

    const {
        manufacturedProducts,
        manufacturingPolicyTypes,
        user,
        loading,
        getManufacturedProducts,
        getManufacturingPolicyTypes,
        getUser,
        clearManufacturedProducts,
        getOrder
    } = props;

    useEffect(() => {
        getUser(currentUser.id);
        getManufacturingPolicyTypes();

        // Cleanup on unmount
        return () => {
            clearManufacturedProducts();
        };
    }, []);

    useEffect(() => {
        if (user && user.manufacturingProductGroups && manufacturingPolicyTypes) {
            const filteredGroups = manufacturingPolicyTypes.filter(policy => user.manufacturingProductGroups.includes(policy.id));
            setUserManufacturingProductGroups(filteredGroups);
        }
    }, [user, manufacturingPolicyTypes]);

    useEffect(() => {
        if (userManufacturingProductGroups.length > 0) {
            const allGroupIds = userManufacturingProductGroups.map(group => group.id);
            getManufacturedProducts({ manufacturingProductGroupTypes: allGroupIds });
        }
    }, [userManufacturingProductGroups]);

    useEffect(() => {
        if (manufacturedProducts && manufacturedProducts.items) {
            const allOrders = manufacturedProducts.items.flatMap(item => item.manufactureProductGroupItems || []);
            setDisplayData(allOrders);
        } else {
            setDisplayData([]);
        }
    }, [manufacturedProducts]);

    const onPrintContent = async (content) => {
        const newTab = window.open('', '_blank');
        if (!newTab) {
            console.error('Popup blocked');
            return;
        }

        const response = await getOrder(content.orderId);
        if (response && response.data) {
            const markup = renderToStaticMarkup(
                <OrderComponentPrint
                    order={response.data}
                    content={content}
                    intl={intl}
                />
            );

            newTab.document.write(markup);
            newTab.document.close();
            newTab.print();
        } else {
            newTab.close();
        }
    }

    // Checkboxes are read-only on dashboard, so this function doesn't need to do anything
    // or can be omitted if we pass readOnlyCheckboxes={true}
    const onContentCheckChange = () => { };

    return (
        <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
            <div className="card card-flush mb-5">
                <div className="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div className="card-title">
                        <h3>{intl.formatMessage({ id: 'PRODUCTIONS.BREADCRUMB.TITLE' })}</h3>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ProductionsList
                        displayData={displayData}
                        loading={loading}
                        expandedOrder={expandedOrder}
                        setExpandedOrder={setExpandedOrder}
                        onContentCheckChange={onContentCheckChange}
                        onPrintContent={onPrintContent}
                        intl={intl}
                        readOnlyCheckboxes={true}
                    />
                </div>
            </div>
        </PolicyChecker>
    );
};

const mapStateToProps = state => {
    return {
        manufacturedProducts: state.Production.manufacturedProducts,
        manufacturingPolicyTypes: state.User.manufacturingPolicyTypes,
        user: state.User.user,
        loading: state.Production.loading,
    };
};

const mapActionsToProps = {
    getManufacturedProducts,
    getManufacturingPolicyTypes,
    getUser,
    clearManufacturedProducts,
    getOrder
}

export default connect(mapStateToProps, mapActionsToProps)(DashboardProductions);
